const LOCALE_KEY = "app_locale";

export default {
    namespaced: true,
    state: {
        locale: localStorage.getItem(LOCALE_KEY) || "zh",
    },
    getters: {
        /** base_new_url 接口 lang 参数：中文为空，英文为 en */
        apiLang: (state) => (state.locale === "en" ? "en" : ""),
    },
    mutations: {
        SET_LOCALE(state, locale) {
            state.locale = locale;
            localStorage.setItem(LOCALE_KEY, locale);
        },
        TOGGLE_LOCALE(state) {
            const next = state.locale === "zh" ? "en" : "zh";
            state.locale = next;
            localStorage.setItem(LOCALE_KEY, next);
        },
    },
    actions: {
        toggleLocale({ commit }) {
            commit("TOGGLE_LOCALE");
        },
        setLocale({ commit }, locale) {
            commit("SET_LOCALE", locale);
        },
    },
};
